import React, { Component } from 'react';
import FullCalendar from 'fullcalendar-reactwrapper';
import  'fullcalendar-reactwrapper/dist/css/fullcalendar.min.css'
import CONSTANTS from "../../../constants";

export default class SelectDateTime extends Component {

    handleDayClick(date) {
        this.props.callbackToUpdateComponent({startDate: date.format(CONSTANTS.DATE.FORMAT.DEFAULT), endDate: date.endOf('week').format(CONSTANTS.DATE.FORMAT.DEFAULT)});
    }

    handleDayRender(date, cell) {
        if(date.format('YYYY-MM-DD') === this.props.startDate) {
            cell.addClass('current-date');
            document.querySelectorAll(`[data-date="${this.props.startDate}"]`)[1].classList.add('current-date');
        }
        return cell;
    }

    render () {
        return (
            <div className='col-xs-12 col-md-12 col-lg-12 calendar'>
                <FullCalendar
                    defaultDate={this.props.startDate}
                    dayRender={this.handleDayRender.bind(this)}
                    id='date-calendar'
                    contentHeight={325}
                    header={{left: 'prev,next today', right: 'title'}}
                    selectable={true}
                    dayClick={this.handleDayClick.bind(this)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/appointments/signup/selectDate.js